import React from 'react';

import { Commentaires } from 'components/FicheDescriptiveDisplay/DetailContent/Commentaires/Commentaires';
import ResponsiveContainer from 'components/ResponsiveContainer';

import { FicheAdminEvents } from './FicheAdminEvents/FicheAdminEvents';
import MainInfoBody from './FicheAdminMain/MainInfoBody/MainInfoBody';
import { MainInfoHeader } from './FicheAdminMain/MainInfoHeader/MainInfoHeader';

import './FicheAdmin.less';

export const FicheAdmin = (): React.ReactElement => {
  return (
    <ResponsiveContainer className="FicheAdmin">
      <div className="MainInfos Section">
        <MainInfoHeader />
        <MainInfoBody />
      </div>
      <div className="ListEvents Section">
        <FicheAdminEvents />
      </div>
      <Commentaires />
    </ResponsiveContainer>
  );
};
